import { render } from "./admin-recommend.vue?vue&type=template&id=54e85bfd&scoped=true&ts=true"
import script from "./admin-recommend.vue?vue&type=script&lang=ts"
export * from "./admin-recommend.vue?vue&type=script&lang=ts"

import "./admin-recommend.vue?vue&type=style&index=0&id=54e85bfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e85bfd"]])

export default __exports__